package fr.manyverse.app.domain.model

/**
 * Platform-agnostic representation of audio data for upload.
 */
data class AudioData(
    val bytes: ByteArray,
    val mimeType: String,
    val fileName: String
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        other as AudioData
        return bytes.contentEquals(other.bytes) && mimeType == other.mimeType && fileName == other.fileName
    }

    override fun hashCode(): Int {
        var result = bytes.contentHashCode()
        result = 31 * result + mimeType.hashCode()
        result = 31 * result + fileName.hashCode()
        return result
    }
}
